import React from "react";
import { Info } from "lucide-react";
import "./ChatComposerPanel.scss";

export type ChatComposerPanelProps = {
  children: React.ReactNode;
  className?: string;
  /** Fully custom notice body (icon strip is still applied). */
  notice?: React.ReactNode;
  /** Dynamic message from the API (e.g. `detail`) — shown verbatim, not rewritten. */
  noticeText?: string | null;
};

/**
 * Unified chat composer chrome: input area + optional info notice strip (pale blue footer).
 * Reuse anywhere you need the Ask DataTram–style input + banner layout.
 */
const ChatComposerPanel: React.FC<ChatComposerPanelProps> = ({
  children,
  className = "",
  notice,
  noticeText,
}) => {
  const noticeBody =
    notice ??
    (noticeText?.trim() ? (
      <span className="chat-composer-panel__notice-plain">{noticeText.trim()}</span>
    ) : null);

  if (!noticeBody) {
    return <>{children}</>;
  }

  return (
    <div className={`chat-composer-panel ${className}`.trim()}>
      <div className="chat-composer-panel__input-slot">{children}</div>
      <div className="chat-composer-panel__divider" aria-hidden />
      <div className="chat-composer-panel__notice" role="status" aria-live="polite">
        <div className="chat-composer-panel__notice-icon">
          <Info aria-hidden />
        </div>
        <div className="chat-composer-panel__notice-body">{noticeBody}</div>
      </div>
    </div>
  );
};

export default ChatComposerPanel;
